import React from 'react'
import { Button } from './Button';
import { useNavigate } from 'react-router-dom';
import FailIconDisplay from './FailIconDisplay';
import { useTranslation } from 'react-i18next';

const InconsistencyError = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    return (
        <div className="custom-container">
            <div className="flex justify-between flex-col items-center h-full pt-[10px]">
                <div className="pt-8">
                    <div>
                        <div className="text-h5 font-bold mb-2 text-flow-heading">{t('inconsistencyError.title')}</div>
                        <div className="text-body text-Gray900">
                            {t('inconsistencyError.description')}
                        </div>
                    </div>
                    <div className="w-[313px] h-[313px]">
                        <div className="mt-4 relative">
                            <FailIconDisplay />
                        </div>
                    </div>
                    <div className="mt-2 px-3 py-3 text-center z-10">
                        <ul className="list-disc list-inside text-Gray900 mt-3">
                        </ul>
                    </div>
                    <div>
                        <Button onClick={() => { navigate("/next", { replace: true }) }} className="mt-4" variant="primaryWithoutIcon">
                            {t('inconsistencyError.startAgain')}
                        </Button>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default InconsistencyError